import { useCallback, useEffect, useMemo, useState } from 'react'
import { SelectOption } from '../../../../../model/selectOption'

export const useProcessScopeSearchSelect = (options: SelectOption[]) => {
  const [searchText, setSearchText] = useState('')
  const [debouncedSearchText, setDebouncedSearchText] = useState('')
  const [temporarySelection, setTemporarySelection] = useState<Set<string>>(
    new Set()
  )

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText)
    }, 300)
    return () => clearTimeout(timer)
  }, [searchText])

  const filteredOptions = useMemo(() => {
    if (!debouncedSearchText) return options
    const lower = debouncedSearchText.toLowerCase()
    return options.filter(option => option.name.toLowerCase().includes(lower))
  }, [options, debouncedSearchText])

  const toggleItem = useCallback((value: string) => {
    setTemporarySelection(prev => {
      const next = new Set(prev)
      if (next.has(value)) {
        next.delete(value)
      } else {
        next.add(value)
      }
      return next
    })
  }, [])

  const applySelection = useCallback(() => {
    return Array.from(temporarySelection)
  }, [temporarySelection])

  const resetToInitial = useCallback((values: string[]) => {
    setTemporarySelection(new Set(values))
    setSearchText('')
    setDebouncedSearchText('')
  }, [])

  return {
    searchText,
    setSearchText,
    filteredOptions,
    temporarySelection,
    toggleItem,
    applySelection,
    resetToInitial,
  }
}
